import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuHorizontalComponent } from "./components/menu-horizontal/menu-horizontal.component";
import { BannerTransversalComponent } from './components/banner-transversal/banner-transversal.component';
import { singleSpaPropsSubject, SingleSpaProps } from '../single-spa/single-spa-props';
import { ShellIframeService } from './services/shell-iframe.service';
import { Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';


@Component({
  selector: 'MenuAsteric-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [MenuHorizontalComponent, BannerTransversalComponent]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'MenuAsteric';
  
  // Props recibidas del microfrontend
  microfrontendProps: SingleSpaProps = {};
  bannerMicrofrontendProps: SingleSpaProps = {};
  private bannerIdsFromApi?: string[];
  private propsSubscription?: Subscription;

  constructor(private readonly shellIframeService: ShellIframeService, private authService: AuthService) {}

  ngOnInit(): void {
    this.propsSubscription = singleSpaPropsSubject.subscribe((props) => {
      this.microfrontendProps = props;
      this.syncBannerMicrofrontendProps();
      this.recrearTokenPermisosSiFalta(props);
    });

    this.shellIframeService.capturarUrlSitio((url) => {
      this.shellIframeService.actualizarUrlSitio(url);
    });
  }

  onBannerIdsChange(bannerIds: string[]): void {
    this.bannerIdsFromApi = bannerIds;
    this.syncBannerMicrofrontendProps();
  }

  private syncBannerMicrofrontendProps(): void {
    const bannerIds = this.microfrontendProps.BannerIds ?? this.bannerIdsFromApi;
    this.bannerMicrofrontendProps = {
      ...this.microfrontendProps,
      ...(bannerIds != null ? { BannerIds: bannerIds } : {})
    };
   
  }

  private recrearTokenPermisosSiFalta(props: SingleSpaProps): void {
    if (this.authService.getIdentidadUsuario()) {
      return;
    }
    const idEmpresa = props.IdEmpresa;
    const idUsuario = props.IdUsuario?.trim();
    if (idEmpresa == null || !idUsuario) {
      return;
    }
    const dominio =
      props.Dominio != null && props.Dominio !== ''
        ? String(props.Dominio)
        : '';
    this.authService
      .ensureTokenPermisosConIdentidad$(
        idEmpresa,
        idUsuario,
        props.IdOrg ?? 0,
        dominio
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    if (this.propsSubscription) {
      this.propsSubscription.unsubscribe();
    }
  }
}

